import { getFlags } from "../../utils/ab_tests"
;(function () {
  const amplitudeFeatureFlagIdentify = async () => {
    const featureFlags = await getFlags()

    if (featureFlags) {
      const identity = new amplitude.Identify()

      Object.keys(featureFlags).forEach((flagName) => {
        identity.set(flagName, `${featureFlags[flagName]}`)
      })

      amplitude.getInstance().identify(identity)
    }
  }

  if (typeof amplitude !== "undefined") {
    amplitudeFeatureFlagIdentify()
  }
})()
